// Algerian Wilayas (58 provinces)
export const WILAYAS = [
  { id: 1, name: 'Adrar', nameAr: 'أدرار' },
  { id: 2, name: 'Chlef', nameAr: 'الشلف' },
  { id: 3, name: 'Laghouat', nameAr: 'الأغواط' },
  { id: 4, name: 'Oum El Bouaghi', nameAr: 'أم البواقي' },
  { id: 5, name: 'Batna', nameAr: 'باتنة' },
  { id: 6, name: 'Béjaïa', nameAr: 'بجاية' },
  { id: 7, name: 'Biskra', nameAr: 'بسكرة' },
  { id: 8, name: 'Béchar', nameAr: 'بشار' },
  { id: 9, name: 'Blida', nameAr: 'البليدة' },
  { id: 10, name: 'Bouira', nameAr: 'البويرة' },
  { id: 11, name: 'Tamanrasset', nameAr: 'تمنراست' },
  { id: 12, name: 'Tébessa', nameAr: 'تبسة' },
  { id: 13, name: 'Tlemcen', nameAr: 'تلمسان' },
  { id: 14, name: 'Tiaret', nameAr: 'تيارت' },
  { id: 15, name: 'Tizi Ouzou', nameAr: 'تيزي وزو' },
  { id: 16, name: 'Alger', nameAr: 'الجزائر' },
  { id: 17, name: 'Djelfa', nameAr: 'الجلفة' },
  { id: 18, name: 'Jijel', nameAr: 'جيجل' },
  { id: 19, name: 'Sétif', nameAr: 'سطيف' },
  { id: 20, name: 'Saïda', nameAr: 'سعيدة' },
  { id: 21, name: 'Skikda', nameAr: 'سكيكدة' },
  { id: 22, name: 'Sidi Bel Abbès', nameAr: 'سيدي بلعباس' },
  { id: 23, name: 'Annaba', nameAr: 'عنابة' },
  { id: 24, name: 'Guelma', nameAr: 'قالمة' },
  { id: 25, name: 'Constantine', nameAr: 'قسنطينة' },
  { id: 26, name: 'Médéa', nameAr: 'المدية' },
  { id: 27, name: 'Mostaganem', nameAr: 'مستغانم' },
  { id: 28, name: "M'Sila", nameAr: 'المسيلة' },
  { id: 29, name: 'Mascara', nameAr: 'معسكر' },
  { id: 30, name: 'Ouargla', nameAr: 'ورقلة' },
  { id: 31, name: 'Oran', nameAr: 'وهران' },
  { id: 32, name: 'El Bayadh', nameAr: 'البيض' },
  { id: 33, name: 'Illizi', nameAr: 'إليزي' },
  { id: 34, name: 'Bordj Bou Arréridj', nameAr: 'برج بوعريريج' },
  { id: 35, name: 'Boumerdès', nameAr: 'بومرداس' },
  { id: 36, name: 'El Tarf', nameAr: 'الطارف' },
  { id: 37, name: 'Tindouf', nameAr: 'تندوف' },
  { id: 38, name: 'Tissemsilt', nameAr: 'تيسمسيلت' },
  { id: 39, name: 'El Oued', nameAr: 'الوادي' },
  { id: 40, name: 'Khenchela', nameAr: 'خنشلة' },
  { id: 41, name: 'Souk Ahras', nameAr: 'سوق أهراس' },
  { id: 42, name: 'Tipaza', nameAr: 'تيبازة' },
  { id: 43, name: 'Mila', nameAr: 'ميلة' },
  { id: 44, name: 'Aïn Defla', nameAr: 'عين الدفلى' },
  { id: 45, name: 'Naâma', nameAr: 'النعامة' },
  { id: 46, name: 'Aïn Témouchent', nameAr: 'عين تموشنت' },
  { id: 47, name: 'Ghardaïa', nameAr: 'غرداية' },
  { id: 48, name: 'Relizane', nameAr: 'غليزان' },
  { id: 49, name: 'Timimoun', nameAr: 'تيميمون' },
  { id: 50, name: 'Bordj Badji Mokhtar', nameAr: 'برج باجي مختار' },
  { id: 51, name: 'Ouled Djellal', nameAr: 'أولاد جلال' },
  { id: 52, name: 'Béni Abbès', nameAr: 'بني عباس' },
  { id: 53, name: 'In Salah', nameAr: 'عين صالح' },
  { id: 54, name: 'In Guezzam', nameAr: 'عين قزام' },
  { id: 55, name: 'Touggourt', nameAr: 'تقرت' },
  { id: 56, name: 'Djanet', nameAr: 'جانت' },
  { id: 57, name: "El M'Ghair", nameAr: 'المغير' },
  { id: 58, name: 'El Meniaa', nameAr: 'المنيعة' },
];
